import { setTerm } from './helpers';

export const setPublishPeriod = setTerm('publish_period');
